import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from 'modules';
import usePlayPause from 'hooks/usePlayPause';
import useKeyPress from 'hooks/useKeyPress';
import PlayPause from 'components/player/controlbar/PlayPause';

/**
 * 재생/정지 컨테이너
 */

const PlayPauseContainer = () => {
  // const 결과 = useSelector(상태 선택 함수);
  const video = useSelector((state: RootState) => state.video);
  const [_, setPaused] = usePlayPause(video.videoDOM as HTMLVideoElement); // 재생/정지 hooks함수
  const playPausePress = useKeyPress(' '); // space bar

  // 키 이벤트 들어올 때 실행
  useEffect(() => {
    if (playPausePress) {
      onClickPlayPause();
    }
  }, [playPausePress]);

  /**
   * 재생/정지 이벤트 클릭 함수
   */
  const onClickPlayPause = () => {
    setPaused();
  };

  return (
    <PlayPause onClickPlayPause={onClickPlayPause} isPaused={video.paused} />
  );
};

export default PlayPauseContainer;
